import {ChangeEventHandler, FC, Form} from 'external/react'

type ConfigurationSelectProps = {
    label: string
    defaultValue?: string
    onChange: ChangeEventHandler<HTMLSelectElement>
    items: Array<any>
}

const ConfigurationSelect: FC<ConfigurationSelectProps> = props => {
    const {label, onChange, defaultValue, items = []} = props
    return (
        <>
            <Form.Label>
                {label}
            </Form.Label>
            <Form.Select defaultValue={defaultValue} onChange={onChange}>
                {items.map((item, index) => (<option value={item.cod} key={index}>{item.value}</option>))}
           </Form.Select>
        </>
    )
}

export {ConfigurationSelect as default}